import Awaken from './Awaken';
import LookAround from './LookAround';
import Hotspots from './Hotspots';
import Exterior from './Exterior';

const Scenes = {
    Awaken,
    LookAround,
    Hotspots,
    Exterior,
};

export default Scenes;
